import api from 'core/api';

export const getSpaces = () => api.get('/spaces/');
